import utils from "core/utils";
import TimeParser from "app/components/common/editor/control/interval/time-parser";
import converter from "core/services/metaStoreService/metaobject-converter";
import statusManagement from "src/status-management";
import wactionStorePersistenceTypes from "../control/wactionstore-persistence/wactionstore-persistence-types.json";
import { loadAscendantsDbSources } from "app/components/flow/designer/component-acendants-loader";
import appStatusSynchronizer from "core/appStatusSynchronizer";
import lastConnectionTestRepository, {
    connectionStatuses,
    getStatusDisplayName
} from "app/components/common/editor/control/connection-text-field/last-connection-test-repository";
import { getDatabaseType } from "app/components/common/editor/control/connection-text-field/connection-test-view";
import ComponentNames from "../../../../../resources/generated/components.json";
import { ComponentKeys } from "../../../../../core/services/componentService/component-service";
var metaObjectHelper = {};

export const resolveSourceValidationDscription = validationResultStatus => {
    const { title, icon } = getStatusDisplayName(validationResultStatus);
    const statusClass = validationResultStatus === connectionStatuses.ok ? "validation-success" : "validation-failed";
    const statusIconClass = validationResultStatus === connectionStatuses.ok ? "icon icon-check" : "status-icon-failed";
    const titleHtml = `<span class="validation-status ${statusClass}"><span class="status-text">${title}</span><span class="status-icon ${statusIconClass}"></span></span>`;
    return { titleHtml, icon };
};

metaObjectHelper.descriptionResolver = function(metaObject, applicationId) {
    var nodeType = metaObject.type.toUpperCase();

    return new Promise(resolve => {
        // Event Table: Input stream, Delete stream
        if (nodeType === utils.ENTITIES.CACHE && metaObject.isEventTable === true) {
            var result = [];
            if (metaObject.adapter && metaObject.adapter.properties && metaObject.adapter.properties.name) {
                result.push("Input: " + converter.getName(metaObject.adapter.properties.name));
            }
            if (metaObject.parser && metaObject.parser.properties && metaObject.parser.properties.name) {
                result.push("Delete: " + converter.getNameWithoutVersion(metaObject.parser.properties.name));
            }
            resolve(result.join(", "));
            return;
        }

        // Source: only when state is created
        if (nodeType === utils.ENTITIES.SOURCE && metaObject.adapter) {
            const handlerName = converter.getName(metaObject.adapter.handler);
            if (getDatabaseType(handlerName)) {
                const status = appStatusSynchronizer.getStatus(applicationId);
                if (statusManagement.isApplicationCreated(status)) {
                    if (metaObject.adapter && metaObject.adapter.handler) {
                        const result = lastConnectionTestRepository.load(metaObject.id, metaObject.adapter.handler);
                        if (!result) {
                            resolve("Not validated");
                            return;
                        }
                        const { titleHtml, icon } = resolveSourceValidationDscription(result.status);
                        resolve({ title: titleHtml, description: result.message, icon });
                        return;
                    } else {
                        resolve("Not validated");
                        return;
                    }
                }
            }
        }

        // Source: Reader, Parser
        // Cache: Reader, Parser
        if (nodeType === utils.ENTITIES.SOURCE || nodeType === utils.ENTITIES.CACHE) {
            var result = [];
            if (metaObject.adapter && metaObject.adapter.handler) {
                result.push(converter.getNameWithoutVersion(metaObject.adapter.handler));
            }
            if (metaObject.parser && metaObject.parser.handler) {
                result.push(converter.getNameWithoutVersion(metaObject.parser.handler));
            }
            resolve(result.join(", "));
            return;
        }

        //Window
        // Sliding:
        // <time or count> Sliding
        // Example “5-minute Sliding” or “1000 Events Sliding”

        // Jumping
        // <time or count> Jumping
        // Example “5-minute Jumping” or “1000 Events Jumping”

        // Partition
        if (nodeType === utils.ENTITIES.WINDOW) {
            var windowDescription = "";

            if (metaObject.size && metaObject.size.count && metaObject.size.count !== -1) {
                windowDescription = metaObject.size.count + " Events ";
            } else if (metaObject.size && metaObject.size.time) {
                windowDescription = TimeParser.toString(metaObject.size.time) + " ";
            }

            if (typeof metaObject.mode !== "undefined") {
                windowDescription += metaObject.mode;
            }

            if (metaObject.partitioningFields && metaObject.partitioningFields.length > 0) {
                windowDescription += ", " + metaObject.partitioningFields.join(", ");
            }
            resolve(windowDescription);
            return;
        }

        //CQ
        // Specify if any exists in the query: Group, Order, Sort, Limit
        if (nodeType === utils.ENTITIES.CQ) {
            if (metaObject.uiconfig && metaObject.uiconfig.subType) {
                resolve(metaObject.uiconfig.subType);
                return;
            }

            if (metaObject.output) {
                resolve("List all fields in " + converter.getNameWithoutVersion(metaObject.output));
                return;
            }

            resolve("");
            return;
        }

        // StriimStore
        // Type
        // Persistence: In-Memory(or DB type ie. “ElasticSearch”)
        if (nodeType === utils.ENTITIES.WACTIONSTORE) {
            var storeDescription = [];
            if (metaObject.contextType) {
                storeDescription.push(converter.getNameWithoutVersion(metaObject.contextType));
            }

            if (
                metaObject.persistence &&
                metaObject.persistence.properties &&
                metaObject.persistence.properties.storageProvider
            ) {
                var storageProvider = metaObject.persistence.properties.storageProvider;
                var selectedPersistence = wactionStorePersistenceTypes.filter(function(el) {
                    return el.id === storageProvider;
                });
                if (selectedPersistence && selectedPersistence.length > 0) {
                    selectedPersistence = selectedPersistence[0];
                    storeDescription.push(selectedPersistence.text);
                } else {
                    storeDescription.push(storageProvider);
                }
            } else {
                storeDescription.push("Elasticsearch");
            }
            resolve(storeDescription.join(", "));
            return;
        }

        //Target
        if (nodeType === utils.ENTITIES.TARGET) {
            var targetResult = [];
            if (metaObject.adapter && metaObject.adapter.handler) {
                targetResult.push(converter.getNameWithoutVersion(metaObject.adapter.handler));
            }
            if (metaObject.formatter && metaObject.formatter.handler) {
                targetResult.push(converter.getNameWithoutVersion(metaObject.formatter.handler));
            }
            if (metaObject.adapter && metaObject.adapter.properties) {
                var databaseProviderType = metaObject.adapter.properties.DatabaseProviderType;
                if (databaseProviderType && databaseProviderType.toLowerCase() !== "default") {
                    targetResult.push(databaseProviderType);
                }
            }
            resolve(targetResult.join(", "));
            return;
        }

        // Process component
        if (nodeType === utils.ENTITIES.OPENPROCESSOR) {
            var pcDescription = [];
            if (metaObject.adapter && metaObject.adapter.handler) {
                pcDescription.push(converter.getNameWithoutVersion(metaObject.adapter.handler));
            }
            resolve(pcDescription.join(", "));
            return;
        }

        if (nodeType === utils.ENTITIES.EXTERNALCACHE) {
            if (
                metaObject.externalCacheProperties &&
                metaObject.externalCacheProperties.properties &&
                metaObject.externalCacheProperties.properties.AdapterName
            ) {
                resolve(converter.getNameWithoutVersion(metaObject.externalCacheProperties.properties.AdapterName));
                return;
            }
        }

        if (nodeType === utils.ENTITIES.ROUTER) {
            if (metaObject.forwardingRules) {
                resolve(metaObject.forwardingRules.length + " forwarding rules");
                return;
            } else {
                resolve("");
            }
        }
        resolve(nodeType);
    });
};

metaObjectHelper.getIconClassByMetaObject = function(metaObject, getObject = false) {
    if (!metaObject?.type) {
        return "";
    }

    const type = metaObject.type.toLowerCase();
    var defaultClass = type;
    var defaultObject = { name: type, className: type, [ComponentKeys.ImageID]: type };

    function getDBProviderType() {
        if (metaObject?.["database-provider-type"]) {
            return metaObject["database-provider-type"];
        }
        if (!metaObject.adapter || !metaObject.adapter.properties) {
            return null;
        }
        return metaObject.adapter.properties.DatabaseProviderType;
    }
    function getApplicationName() {
        if (metaObject?.ApplicationAPIReaderName) return metaObject.ApplicationAPIReaderName;
        if (!metaObject.adapter || !metaObject.adapter.properties) {
            return null;
        }
        return metaObject.adapter.properties.ApplicationAPIReaderName;
    }

    function getSalesforceSuiteConnectorName() {
        if (metaObject?.SalesforceSuiteConnectorName) return metaObject.SalesforceSuiteConnectorName;
        if (!metaObject.adapter || !metaObject.adapter.properties) {
            return null;
        }
        return metaObject.adapter.properties.SalesforceSuiteConnectorName;
    }

    function checkAdapterByHandler(name) {
        return (
            (metaObject?.adapter?.handler && converter.getNameWithoutVersion(metaObject.adapter.handler) === name) ||
            metaObject["adapter-name"] === name ||
            metaObject["adapterName"] === name
        );
    }

    function checkParser(name) {
        return metaObject?.parser?.handler?.includes(name);
    }

    function getObjectOrIcon(component) {
        if (!component) {
            console.warn(`Image asset not found for ${component}. Using default icon.`);
            component = ComponentNames.Striim;
        }
        return getObject ? component : component[ComponentKeys.ImageID];
    }

    function getDataFormatForExternalSource() {
        return metaObject?.properties?.properties?.dataFormat;
    }

    if (metaObject.type === utils.ENTITIES.SOURCE) {
        // handlers
        if (checkAdapterByHandler("DatabaseReader")) {
            var dbReader = getDBProviderType();

            switch (dbReader) {
                case "MySQL":
                    return getObjectOrIcon(ComponentNames.MySQLIL);
                case "MariaDB":
                    return getObjectOrIcon(ComponentNames.MariaDBIL);
                case "Oracle":
                    return getObjectOrIcon(ComponentNames.OracleIL);
                case "Postgres":
                    return getObjectOrIcon(ComponentNames.PostgreSQLIL);
                case "SQLServer":
                    return getObjectOrIcon(ComponentNames.MSSQLIL);
                case "MariaDBXpand":
                    return getObjectOrIcon(ComponentNames.MariaDBXpandIL);
                case "Snowflake":
                    return getObjectOrIcon(ComponentNames.SnowflakeILReader);
                case "BigQuery":
                    return getObjectOrIcon(ComponentNames.BigQueryILReader);
                case "yugabytedb":
                    return getObjectOrIcon(ComponentNames.YugabyteDBReader);
                case "Db2zOS":
                    return getObjectOrIcon(ComponentNames.Db2zOSIL);
                case "CrunchyData":
                    return getObjectOrIcon(ComponentNames.CrunchyDataILReader);
                case "Neon":
                    return getObjectOrIcon(ComponentNames.NeonILReader);
                default:
                    return getObjectOrIcon(ComponentNames.DatabaseSource);
            }
        }
        if (checkAdapterByHandler("HTTPReader")) {
            return getObjectOrIcon(ComponentNames.Http);
        }
        if (checkAdapterByHandler("JMSReader")) {
            return getObjectOrIcon(ComponentNames.JMS);
        }
        if (checkAdapterByHandler("KafkaReader")) {
            return getObjectOrIcon(ComponentNames.Kafka);
        }
        if (checkAdapterByHandler("HDFSReader")) {
            return getObjectOrIcon(ComponentNames.HDFS);
        }
        if (checkAdapterByHandler("MQTTReader")) {
            return getObjectOrIcon(ComponentNames.MQTT);
        }
        if (checkAdapterByHandler("TCPReader")) {
            return getObjectOrIcon(ComponentNames.TCP);
        }
        if (checkAdapterByHandler("MapRFSReader")) {
            return getObjectOrIcon(ComponentNames.MapRFSReader);
        }
        // UDP
        if (checkAdapterByHandler("UDPReader")) {
            if (checkParser("CollectdParser")) {
                return getObjectOrIcon(ComponentNames.CollectD);
            }
            if (checkParser("NetflowParser")) {
                return getObjectOrIcon(ComponentNames.NetFlow);
            }
            if (checkParser("SNMPParser")) {
                return getObjectOrIcon(ComponentNames.File);
            }
            return getObjectOrIcon(ComponentNames.UDP);
        }
        if (checkAdapterByHandler("SalesForceReader")) {
            return getObjectOrIcon(ComponentNames.Salesforce);
        }
        if (checkAdapterByHandler("OracleReader")) {
            return getObjectOrIcon(ComponentNames.OracleCDC);
        }
        if (checkAdapterByHandler("OJet")) {
            return getObjectOrIcon(ComponentNames.OJet);
        }
        if (checkAdapterByHandler("MSSqlReader")) {
            return getObjectOrIcon(ComponentNames.MSSQLCDC);
        }
        if (checkAdapterByHandler("CosmosDBReader")) {
            return getObjectOrIcon(ComponentNames.CosmosDBReader);
        }
        if (checkAdapterByHandler("MongoCosmosDBReader")) {
            return getObjectOrIcon(ComponentNames.MongoCosmosDBReader);
        }
        if (checkAdapterByHandler("MSJet")) {
            return getObjectOrIcon(ComponentNames.MSJet);
        }
        if (checkAdapterByHandler("MysqlReader")) {
            return getObjectOrIcon(ComponentNames.MySQLCDC);
        }
        if (checkAdapterByHandler("PostgreSQLReader")) {
            return getObjectOrIcon(ComponentNames.PostgreSQLReader);
        }
        if (checkAdapterByHandler("MongoDBReader")) {
            return getObjectOrIcon(ComponentNames.MongoDBReader);
        }
        if (checkAdapterByHandler("HPNonStopEnscribeReader")) {
            return getObjectOrIcon(ComponentNames.HPNonStopCDC);
        }
        if (checkAdapterByHandler("HPNonStopSQLMPReader")) {
            return getObjectOrIcon(ComponentNames.HPNonStopSQLMP);
        }
        if (checkAdapterByHandler("HPNonStopSQLMXReader")) {
            return getObjectOrIcon(ComponentNames.HPNonStopSQLMX);
        }
        if (checkAdapterByHandler("GGTrailParser")) {
            return getObjectOrIcon(ComponentNames.GoldenGate);
        }
        if (checkAdapterByHandler("GGTrailReader")) {
            return getObjectOrIcon(ComponentNames.GGTrail);
        }
        if (checkAdapterByHandler("OPCUAReader")) {
            return getObjectOrIcon(ComponentNames.OPCUAReader);
        }
        if (checkAdapterByHandler("IncrementalBatchReader")) {
            return getObjectOrIcon(ComponentNames.IncrementalBatchReader);
        }
        if (checkAdapterByHandler("SpannerBatchReader")) {
            return getObjectOrIcon(ComponentNames.SpannerBatchReader);
        }
        if (checkAdapterByHandler("S3Reader")) {
            return getObjectOrIcon(ComponentNames.S3Reader);
        }
        if (checkAdapterByHandler("JMXReader")) {
            return getObjectOrIcon(ComponentNames.JMXReader);
        }
        if (checkAdapterByHandler("MariaDBReader")) {
            return getObjectOrIcon(ComponentNames.MariaDBReader);
        }
        if (checkAdapterByHandler("MariaDBXpandReader")) {
            return getObjectOrIcon(ComponentNames.MariaDBXpandReader);
        }
        if (checkAdapterByHandler("GCSReader")) {
            return getObjectOrIcon(ComponentNames.GCSReader);
        }
        if (checkAdapterByHandler("SalesForcePushTopicReader")) {
            return getObjectOrIcon(ComponentNames.SalesforcePushTopic);
        }
        if (checkAdapterByHandler("ADLSReader")) {
            return getObjectOrIcon(ComponentNames.ADLSReader);
        }
        // parsers
        if (checkParser("GGTrailParser")) {
            return getObjectOrIcon(ComponentNames.GoldenGate);
        }
        if (checkParser("XMLParser")) {
            return getObjectOrIcon(ComponentNames.XML);
        }
        if (checkParser("JSONParser")) {
            return getObjectOrIcon(ComponentNames.JSON);
        }
        if (checkParser("AvroParser") && checkAdapterByHandler("FileReader")) {
            return getObjectOrIcon(ComponentNames.Avro);
        }
        if (checkParser("AALParser")) {
            return getObjectOrIcon(ComponentNames.ApacheAccessLog);
        }
        if (checkParser("NVPParser")) {
            return getObjectOrIcon(ComponentNames.NameValuePair);
        }
        if (checkParser("FreeFormTextParser")) {
            return getObjectOrIcon(ComponentNames.FreeFormText);
        }
        if (checkParser("BinaryParser")) {
            return getObjectOrIcon(ComponentNames.Binary);
        }
        if (checkParser("CobolCopybookParser")) {
            return getObjectOrIcon(ComponentNames.CobolCopybookParser);
        }
        if (checkParser("DSVParser")) {
            return getObjectOrIcon(ComponentNames.DelimiterSeparatedValues);
        }
        if (checkAdapterByHandler("FileReader")) {
            return getObjectOrIcon(ComponentNames.File);
        }
        if (checkAdapterByHandler("MultiFileReader")) {
            return getObjectOrIcon(ComponentNames.MultiFileReader);
        }
        if (checkAdapterByHandler("WindowsEventLogReader")) {
            return getObjectOrIcon(ComponentNames.WindowsEventLog);
        }
        if (checkAdapterByHandler("DatabaseReader")) {
            return getObjectOrIcon(ComponentNames.DatabaseSource);
        }

        if (checkAdapterByHandler("ServiceNowReader")) {
            return getObjectOrIcon(ComponentNames.ServiceNowReader);
        }
        if (checkAdapterByHandler("SalesforcePardotReader")) {
            return getObjectOrIcon(ComponentNames.SalesforcePardotReader);
        }
        if (checkAdapterByHandler("HubSpotReader")) {
            return getObjectOrIcon(ComponentNames.HubSpotReader);
        }
        if (checkAdapterByHandler("SalesforceCDCReader")) {
            return getObjectOrIcon(ComponentNames.SalesforceCDCReader);
        }
        if (checkAdapterByHandler("SalesForcePlatformEventReader")) {
            return getObjectOrIcon(ComponentNames.SalesforcePlatformEvent);
        }
        if (checkAdapterByHandler("SnowflakeReader")) {
            return getObjectOrIcon(ComponentNames.SnowflakeCDCReader);
        }
        if (checkAdapterByHandler("GoogleAdsReader")) {
            return getObjectOrIcon(ComponentNames.GoogleAdsReader);
        }
        //DO-NOT-REMOVE-BELOW-COMMENT
        //add-new-reader
        if (checkAdapterByHandler("MicrosoftDynamics365Reader")) {
            return getObjectOrIcon(ComponentNames.MicrosoftDynamics365Reader);
        }
        if (checkAdapterByHandler("MicrosoftDynamics365BusinessCentralReader")) {
            return getObjectOrIcon(ComponentNames.MicrosoftDynamics365BusinessCentralReader);
        }
        if (checkAdapterByHandler("BambooHrReader")) {
            return getObjectOrIcon(ComponentNames.BambooHrReader);
        }
        if (checkAdapterByHandler("YugabyteReader")) {
            return getObjectOrIcon(ComponentNames.YugabyteCDC);
        }
        if (checkAdapterByHandler("YugabyteDBReader")) {
            return getObjectOrIcon(ComponentNames.YugabyteDBReader);
        }
        if (checkAdapterByHandler("JiraReader")) {
            return getObjectOrIcon(ComponentNames.JiraReader);
        }
        if (checkAdapterByHandler("LinkedInAdsReader")) {
            return getObjectOrIcon(ComponentNames.LinkedInAdsReader);
        }
        if (checkAdapterByHandler("StripeReader")) {
            return getObjectOrIcon(ComponentNames.StripeReader);
        }
        if (checkAdapterByHandler("ZendeskReader")) {
            return getObjectOrIcon(ComponentNames.ZendeskReader);
        }
        if (checkAdapterByHandler("IntercomReader")) {
            return getObjectOrIcon(ComponentNames.IntercomReader);
        }
        if (checkAdapterByHandler("GoogleSheetsReader")) {
            return getObjectOrIcon(ComponentNames.GoogleSheetsReader);
        }
        if (checkAdapterByHandler("GoogleAnalyticsReader")) {
            return getObjectOrIcon(ComponentNames.GoogleAnalyticsReader);
        }
        if (checkAdapterByHandler("PaymoReader")) {
            return getObjectOrIcon(ComponentNames.PaymoReader);
        }
        if (checkAdapterByHandler("WorkdayReader")) {
            return getObjectOrIcon(ComponentNames.WorkdayReader);
        }
        if (checkAdapterByHandler("SpannerDatabaseReader")) {
            return getObjectOrIcon(ComponentNames.SpannerDatabaseReader);
        }
        return getObjectOrIcon(defaultObject);
    }

    if (metaObject.type === utils.ENTITIES.CQ && metaObject.uiconfig) {
        if (metaObject.uiconfig.subType === "Field Masker") {
            return getObjectOrIcon(ComponentNames.TransformationMasking);
        } else if (metaObject.uiconfig.subType === "Field Remover") {
            return getObjectOrIcon(ComponentNames.TransformationFieldRemover);
        } else if (metaObject.uiconfig.subType === "Field Renamer") {
            return getObjectOrIcon(ComponentNames.TransformationFieldRenamer);
        } else if (metaObject.uiconfig.subType === "Field Type Modifier") {
            return getObjectOrIcon(ComponentNames.TransformationFieldTypeModifier);
        } else if (metaObject.uiconfig.subType === "Field Value Filter") {
            return getObjectOrIcon(ComponentNames.TransformationFieldFilter);
        } else if (metaObject.uiconfig.subType === "Field Splitter") {
            return getObjectOrIcon(ComponentNames.TransformationFieldSplitter);
        } else if (metaObject.uiconfig.subType === "Field Enricher") {
            return getObjectOrIcon(ComponentNames.TransformationFieldEnricher);
        } else if (metaObject.uiconfig.subType === "JSON Object Mapper") {
            return getObjectOrIcon(ComponentNames.TransformationJsonReader);
        } else if (metaObject.uiconfig.subType === "To DB Event") {
            return getObjectOrIcon(ComponentNames.TransformationTypedEventToWaDbEvent);
        } else if (metaObject.uiconfig.subType === "Field Adder") {
            return getObjectOrIcon(ComponentNames.TransformationFieldAdder);
        } else if (metaObject.uiconfig.subType === "Metadata Filter") {
            return getObjectOrIcon(ComponentNames.TransformationWaeMetaFilter);
        } else if (metaObject.uiconfig.subType === "Table Filter") {
            return getObjectOrIcon(ComponentNames.TransformationWaeDbTableFilter);
        } else if (metaObject.uiconfig.subType === "Operation Filter") {
            return getObjectOrIcon(ComponentNames.TransformationWaeOperatorFilter);
        } else if (metaObject.uiconfig.subType === "Custom Data Adder") {
            return getObjectOrIcon(ComponentNames.TransformationWaeAddUserData);
        } else if (metaObject.uiconfig.subType === "To Event") {
            return getObjectOrIcon(ComponentNames.TransformationWaeToTypedEvent);
        } else if (metaObject.uiconfig.subType === "To Staging") {
            return getObjectOrIcon(ComponentNames.TransformationWaeToDwStage);
        } else if (metaObject.uiconfig.subType === "Data Modifier") {
            return getObjectOrIcon(ComponentNames.TransformationWaeDataModifier);
        } else if (metaObject.uiconfig.subType === "Shield") {
            return getObjectOrIcon(ComponentNames.TransformationShield);
        } else if (metaObject.uiconfig.subType === "Sentinel") {
            return getObjectOrIcon(ComponentNames.TransformationSentinel);
        } else if (metaObject.uiconfig.subType === "Foreseer") {
            return getObjectOrIcon(ComponentNames.Foreseer);
        } else if (metaObject.uiconfig.subType === "Euclid") {
            return getObjectOrIcon(ComponentNames.Euclid);
        }
    }
    if (metaObject.type === utils.ENTITIES.SENTINEL) {
        return getObjectOrIcon(ComponentNames.TransformationSentinel);
    }
    if (metaObject.type === utils.ENTITIES.CACHE) {
        if (checkAdapterByHandler("FileReader")) {
            return getObjectOrIcon(ComponentNames.FileCache);
        } else if (checkAdapterByHandler("DatabaseReader")) {
            return getObjectOrIcon(ComponentNames.DBCache);
        } else if (checkAdapterByHandler("HDFSReader")) {
            return getObjectOrIcon(ComponentNames.HDFSCache);
        } else if (metaObject.isEventTable === true) {
            return getObjectOrIcon(ComponentNames.BaseEventTable);
        }

        return defaultClass;
    }

    if (metaObject.type === utils.ENTITIES.TARGET) {
        if (checkAdapterByHandler("DatabaseWriter")) {
            var dbWriter = getDBProviderType();
            switch (dbWriter) {
                case "Oracle":
                    return getObjectOrIcon(ComponentNames.OutputOracleDatabase);
                case "Vertica":
                    return getObjectOrIcon(ComponentNames.VerticaWriter);
                case "SQLServer":
                    return getObjectOrIcon(ComponentNames.OutputSQLServerDatabase);
                case "MySQL":
                    return getObjectOrIcon(ComponentNames.OutputMySQLDatabase);
                case "MemSQL":
                    return getObjectOrIcon(ComponentNames.OutputMemSQLDatabase);
                case "Cassandra":
                    return getObjectOrIcon(ComponentNames.CassandraWriter);
                case "SQLMX":
                    return getObjectOrIcon(ComponentNames.OutputHPSQLMXDatabase);
                case "SAPHANA":
                    return getObjectOrIcon(ComponentNames.SAPHANAWriter);
                case "MariaDB":
                    return getObjectOrIcon(ComponentNames.MariaDBDatabase);
                case "Postgres":
                    return getObjectOrIcon(ComponentNames.OutputPostgresDatabase);
                case "AzurePostgres":
                    return getObjectOrIcon(ComponentNames.AzurePostgreSqlWriter);
                case "CloudSqlPostgres":
                    return getObjectOrIcon(ComponentNames.CloudSqlPostgreSqlWriter);
                case "CloudSqlMySQL":
                    return getObjectOrIcon(ComponentNames.CloudSqlMySqlWriter);
                case "CloudSqlSQLServer":
                    return getObjectOrIcon(ComponentNames.CloudSqlSQLServerWriter);
                case "Yellowbrick":
                    return getObjectOrIcon(ComponentNames.Yellowbrick);
                case "Db2Zos":
                    return getObjectOrIcon(ComponentNames.Db2Zos);
                case "CrunchyData":
                    return getObjectOrIcon(ComponentNames.CrunchyDataWriter);
                case "Neon":
                    return getObjectOrIcon(ComponentNames.NeonWriter);
                case "Lakebase":
                    return getObjectOrIcon(ComponentNames.LakebaseWriter);
            }
            return getObjectOrIcon(ComponentNames.Database);
        } else if (checkAdapterByHandler("HBaseWriter")) {
            return getObjectOrIcon(ComponentNames.HBase);
        } else if (checkAdapterByHandler("HDFSWriter")) {
            return getObjectOrIcon(ComponentNames.OutputHDFS);
        } else if (checkAdapterByHandler("GCSWriter")) {
            return getObjectOrIcon(ComponentNames.GCSWriter);
        } else if (checkAdapterByHandler("ClouderaHiveWriter")) {
            return getObjectOrIcon(ComponentNames.ClouderaHiveWriter);
        } else if (checkAdapterByHandler("HortonworksHiveWriter")) {
            return getObjectOrIcon(ComponentNames.HortonWorksHiveWriter);
        } else if (checkAdapterByHandler("JMSWriter")) {
            return getObjectOrIcon(ComponentNames.OutputJMS);
        } else if (checkAdapterByHandler("SpannerWriter")) {
            return getObjectOrIcon(ComponentNames.SpannerWriter);
            // } else if (checkAdapterByHandler("KafkaWriter")) {
            //     return getObjectOrIcon(ComponentNames.OutputKafka);
        } else if (checkAdapterByHandler("HTTPWriter")) {
            return getObjectOrIcon(ComponentNames.HTTPWriter);
        } else if (checkAdapterByHandler("FileWriter")) {
            return getObjectOrIcon(ComponentNames.OutputFile);
        } else if (checkAdapterByHandler("MQTTWriter")) {
            return getObjectOrIcon(ComponentNames.OutputMQTT);
        } else if (checkAdapterByHandler("S3Writer")) {
            return getObjectOrIcon(ComponentNames.S3);
        } else if (checkAdapterByHandler("RedshiftWriter")) {
            return getObjectOrIcon(ComponentNames.RedSh);
        } else if (checkAdapterByHandler("SysOut")) {
            return getObjectOrIcon(ComponentNames.SysOut);
        } else if (checkAdapterByHandler("ClickatellSMSAdapter")) {
            return getObjectOrIcon(ComponentNames.SMS);
        } else if (checkAdapterByHandler("EmailAdapter")) {
            return getObjectOrIcon(ComponentNames.Email);
        } else if (checkAdapterByHandler("WebAlertAdapter")) {
            return getObjectOrIcon(ComponentNames.WebAlertUI);
        } else if (checkAdapterByHandler("BigQueryWriter")) {
            return getObjectOrIcon(ComponentNames.BigQuery);
        } else if (checkAdapterByHandler("MapRDBWriter")) {
            return getObjectOrIcon(ComponentNames.MapRDBWriter);
        } else if (checkAdapterByHandler("MapRStreamWriter")) {
            return getObjectOrIcon(ComponentNames.MapRStreamWriter);
        } else if (checkAdapterByHandler("HazelcastWriter")) {
            return getObjectOrIcon(ComponentNames.HazelcastWriter);
        } else if (checkAdapterByHandler("AzureBlobWriter")) {
            return getObjectOrIcon(ComponentNames.AzureBlobWriter);
        } else if (checkAdapterByHandler("AzureEventHubWriter")) {
            return getObjectOrIcon(ComponentNames.AzureEventHubWriter);
        } else if (checkAdapterByHandler("KuduWriter")) {
            return getObjectOrIcon(ComponentNames.KuduWriter);
        } else if (checkAdapterByHandler("JPAWriter")) {
            return getObjectOrIcon(ComponentNames.JPAWriter);
        } else if (checkAdapterByHandler("AzureSQLDWHWriter")) {
            return getObjectOrIcon(ComponentNames.AzureSQLDWHWriter);
        } else if (checkAdapterByHandler("HiveWriter")) {
            return getObjectOrIcon(ComponentNames.HiveWriter);
        } else if (checkAdapterByHandler("SnowflakeWriter")) {
            return getObjectOrIcon(ComponentNames.SnowflakeWriter);
        } else if (checkAdapterByHandler("DeltaLakeWriter")) {
            return getObjectOrIcon(ComponentNames.DeltaLakeWriter);
        } else if (checkAdapterByHandler("KinesisWriter")) {
            return getObjectOrIcon(ComponentNames.KinesisWriter);
        } else if (checkAdapterByHandler("CosmosDBWriter")) {
            return getObjectOrIcon(ComponentNames.CosmosDBWriter);
        } else if (checkAdapterByHandler("ADLSGen2Writer")) {
            return getObjectOrIcon(ComponentNames.AzureDataLakeStoreGen2);
        } else if (checkAdapterByHandler("AzureDataLakeStoreGen2")) {
            return getObjectOrIcon(ComponentNames.AzureDataLakeStoreGen2);
        } else if (checkAdapterByHandler("GooglePubSubWriter")) {
            return getObjectOrIcon(ComponentNames.GooglePubSubWriter);
        } else if (checkAdapterByHandler("CassandraCosmosDBWriter")) {
            return getObjectOrIcon(ComponentNames.CassandraCosmosDBWriter);
        } else if (checkAdapterByHandler("CassandraWriter")) {
            return getObjectOrIcon(ComponentNames.CassandraWriter);
        } else if (checkAdapterByHandler("MongoCosmosDBWriter")) {
            return getObjectOrIcon(ComponentNames.MongoCosmosDBWriter);
        } else if (checkAdapterByHandler("MongoDBWriter")) {
            return getObjectOrIcon(ComponentNames.MongoDbWriter);
        } else if (checkAdapterByHandler("SlackAlertAdapter")) {
            return getObjectOrIcon(ComponentNames.Slack);
        } else if (checkAdapterByHandler("SalesforceWriter")) {
            return getObjectOrIcon(ComponentNames.SalesforceWriter);
        } else if (checkAdapterByHandler("TeamsAlertAdapter")) {
            return getObjectOrIcon(ComponentNames.TeamsAlertAdapter);
        } else if (checkAdapterByHandler("MapRFSWriter")) {
            return getObjectOrIcon(ComponentNames.MapRFSWriter);
        } else if (checkAdapterByHandler("ServiceNowWriter")) {
            return getObjectOrIcon(ComponentNames.ServiceNowWriter);
        } else if (checkAdapterByHandler("HDInsightKafkaWriter")) {
            return getObjectOrIcon(ComponentNames.HDInsightKafkaWriter);
        } else if (checkAdapterByHandler("HDInsightHDFSWriter")) {
            return getObjectOrIcon(ComponentNames.HDInsightHDFSWriter);
        } else if (checkAdapterByHandler("FabricDataWarehouseWriter")) {
            return getObjectOrIcon(ComponentNames.FabricDataWarehouseWriter);
        } else if (checkAdapterByHandler("FabricLakehouseFileWriter")) {
            return getObjectOrIcon(ComponentNames.FabricLakehouseFileWriter);
        } else if (checkAdapterByHandler("SalesforceMarketingCloudWriter")) {
            return getObjectOrIcon(ComponentNames.SalesforceMarketingCloudWriter);
        } else if (checkAdapterByHandler("ClickHouseWriter")) {
            return getObjectOrIcon(ComponentNames.ClickHouseWriter);
        }
        //DO-NOT-REMOVE-BELOW-COMMENT
        //add-new-writer
        else if (checkAdapterByHandler("MicrosoftDataverseWriter")) {
            return getObjectOrIcon(ComponentNames.MicrosoftDataverseWriter);
        } else if (checkAdapterByHandler("FabricMirrorWriter")) {
            return getObjectOrIcon(ComponentNames.FabricMirrorWriter);
        } else if (checkAdapterByHandler("SpannerPGDialectWriter")) {
            return getObjectOrIcon(ComponentNames.SpannerPGDialectWriter);
        } else if (checkAdapterByHandler("MicrosoftDynamics365BusinessCentralWriter")) {
            return getObjectOrIcon(ComponentNames.MicrosoftDynamics365BusinessCentralWriter);
        } else if (checkAdapterByHandler("MicrosoftDataverseWriter")) {
            return getObjectOrIcon(ComponentNames.MicrosoftDataverseWriter);
        } else if (checkAdapterByHandler("IcebergWriter")) {
            return getObjectOrIcon(ComponentNames.IcebergWriter);
        } else if (checkAdapterByHandler("GCPLakehouseWriter")) {
            return getObjectOrIcon(ComponentNames.GCPLakehouseWriter);
        } else if (checkAdapterByHandler("MicrosoftDynamics365Writer")) {
            return getObjectOrIcon(ComponentNames.MicrosoftDynamics365Writer);
        } else if (checkAdapterByHandler("FabricMirrorWriter")) {
            return getObjectOrIcon(ComponentNames.FabricMirrorWriter);
        } else if (checkAdapterByHandler("SpannerPGDialectWriter")) {
            return getObjectOrIcon(ComponentNames.SpannerPGDialectWriter);
        } else if (checkAdapterByHandler("HubSpotWriter")) {
            return getObjectOrIcon(ComponentNames.HubSpotWriter);
        } else if (checkAdapterByHandler("FirestoreWriter")) {
            return getObjectOrIcon(ComponentNames.FirestoreWriter);
        }

        return getObjectOrIcon(defaultObject);
    }

    if (metaObject.type === "WACTIONSTORE") {
        return "striim";
    }

    if (metaObject.type === "STREAM") {
        return "stream";
    }

    if (metaObject.type === utils.ENTITIES.OPENPROCESSOR) {
        return getObjectOrIcon(ComponentNames.BaseProcessComponent);
    }

    if (metaObject.type === utils.ENTITIES.EXTERNALSOURCE) {
        const dataFormat = getDataFormatForExternalSource();
        switch (dataFormat) {
            case "AvroDebezium":
                return getObjectOrIcon(ComponentNames.AvroDebezium);
            case "AvroExternalDb2zOS":
                return getObjectOrIcon(ComponentNames.AvroExternalDb2zOS);
            default:
                return getObjectOrIcon(ComponentNames.BaseExternalSource);
        }
    }

    return defaultClass;
};

metaObjectHelper.isWAEventDataType = function(dataType) {
    return dataType === "Global.TYPE.WAEvent";
};

metaObjectHelper.hasValidDbSource = function(streamId, forceRefresh) {
    let key = "isdb_" + streamId;

    return new Promise(resolve => {
        if (forceRefresh) {
            localStorage.removeItem(key);
        }

        let result = localStorage.getItem(key);
        if (result != null) {
            resolve(result === "true");
            return;
        }

        loadAscendantsDbSources(streamId).then(result => {
            var resultFromPromise = result.length === 1;
            localStorage.setItem(key, resultFromPromise);
            resolve(resultFromPromise);
        });
    });
};

export default metaObjectHelper;
